export const Messages ={
    REQUIRED_FILE:"Please upload file.",
    REQUIRED_VIDEO_FILE:"Only videos are allowed."
}